import React from 'react'
import { fundsManagementTracker } from '@mobi/account/Common/Analytics'
import type { CancellationState, Transaction } from '@core/Areas/Account/Pages/Activity/types'
import { ButtonBlock } from '@core/Components/Buttons/ButtonBlock'
import { post } from '@core/Services/ApiService'
import { UpdateAccountBalance } from '@core/State/UserAccount/userAccountDriver'
import { PendingWithdrawalDetailsStyled } from './PendingWithdrawalDetails.styles'

export const PendingWithdrawalDetails: React.FC<{
  cancellationState: CancellationState
  setCancellationState: React.Dispatch<React.SetStateAction<CancellationState>>
  transactionNumber: Transaction['tranTransSeq']
}> = ({ cancellationState, setCancellationState, transactionNumber }) => {
  return (
    <PendingWithdrawalDetailsStyled data-testid='transaction-pending-withdrawal'>
      <ButtonBlock
        data-testid='transaction-cancel-withdrawal'
        onClick={() => cancelWithdrawal(setCancellationState, transactionNumber)}
        disabled={cancellationState === 'waiting'}
        isBusy={cancellationState === 'waiting'}
      >
        {cancellationState === 'initial' && <span>Cancel Withdrawal</span>}
      </ButtonBlock>
    </PendingWithdrawalDetailsStyled>
  )
}

// =============
// Local Helpers
// =============

export interface WithdrawalCancellationResponse {
  success: boolean
  failureReason: string | null
  cancelTransactionNumber: number | null
  cancelTransactionTimestamp: Date | null
  balance: number | null
}

const cancelWithdrawal = async (
  setState: React.Dispatch<React.SetStateAction<CancellationState>>,
  transactionNumber: Transaction['tranTransSeq']
) => {
  setState('waiting')

  const response = await post<WithdrawalCancellationResponse>({
    url: '/$_/accountActivity/tickets/transactions/withdrawal-cancel',
    body: {
      TransactionNumber: transactionNumber,
    },
  }).catch(() => {
    setState('error')
  })

  if (!response || !response.success) {
    setState('error')
  } else {
    setState('completed')

    fundsManagementTracker({
      interaction_type: 'Cancel Withdrawal',
      location: 'Transaction History',
    })

    if (UpdateAccountBalance !== undefined && response.balance !== null) {
      UpdateAccountBalance({ balance: response.balance })
    }
  }
}
